import { Add as AddIcon, Clear as ClearIcon } from "@mui/icons-material";
import { Box, Chip, chipClasses, ListItem } from "@mui/material";
import { Button, Typography } from "@platform/design-system";

interface Props {
  label: string;
  contacts: string[];
  isSalesRep?: boolean;
  onDeleteContact: (contact: string) => void;
  onAddContact: () => void;
}
const DrawerCarrierContactsListItem = ({
  label,
  contacts,
  isSalesRep = false,
  onDeleteContact,
  onAddContact,
}: Props): React.JSX.Element => {
  const hasContacts = contacts.length > 0;
  return (
    <ListItem disablePadding alignItems="flex-start">
      <Typography
        variant="body-medium"
        sx={{ px: 1, py: 0.5 }}
        minWidth={100}
        color={isSalesRep && !hasContacts ? "danger" : "textSecondary"}
      >
        {label}
      </Typography>
      <Box maxWidth="calc(100% - 100px)" display="flex" flexWrap="wrap">
        {contacts.map((contact) => (
          <Chip
            key={`contact-${label}-${contact}`}
            variant="plain"
            label={contact}
            title={contact}
            onDelete={() => onDeleteContact(contact)}
            deleteIcon={<ClearIcon />}
            sx={{
              [`& .${chipClasses.deleteIcon}`]: {
                fontSize: 18,
              },
            }}
          />
        ))}
        {hasContacts ? (
          <Button
            variant="ghost"
            onClick={onAddContact}
            sx={{
              fontSize: 13,
              fontWeight: "fontWeightRegular",
              textTransform: "none",
              minWidth: "auto",
              px: 0,
              color: "text.secondary",
            }}
          >
            <AddIcon fontSize="small" />
          </Button>
        ) : (
          <Chip
            key={`contact-add-${label}`}
            variant="plain"
            icon={<AddIcon fontSize="small" />}
            label={"Add email"}
            onClick={onAddContact}
            color={isSalesRep ? "error" : "default"}
          />
        )}
      </Box>
    </ListItem>
  );
};

export { DrawerCarrierContactsListItem };
